import { render, staticRenderFns } from "./CreateSmsDialog.vue?vue&type=template&id=0b50878a&scoped=true"
import script from "./CreateSmsDialog.vue?vue&type=script&lang=js"
export * from "./CreateSmsDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateSmsDialog.vue?vue&type=style&index=0&id=0b50878a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b50878a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b50878a')) {
      api.createRecord('0b50878a', component.options)
    } else {
      api.reload('0b50878a', component.options)
    }
    module.hot.accept("./CreateSmsDialog.vue?vue&type=template&id=0b50878a&scoped=true", function () {
      api.rerender('0b50878a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/CreateSmsDialog.vue"
export default component.exports